import { render, staticRenderFns } from "./OverviewBarChart.vue?vue&type=template&id=f9366118&"
import script from "./OverviewBarChart.vue?vue&type=script&lang=js&"
export * from "./OverviewBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
